import {
  Component,
  ComponentRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  ViewContainerRef,
  OnInit,
} from '@angular/core';
import { MandantConfigService } from '@strategies/mandant-config.service';

@Component({
  selector: 'base-container',
  template: '<ng-template #dynamic></ng-template>',
  styleUrls: [],
  standalone: false,
})
export abstract class BaseDynamicContainer implements OnChanges, OnInit {
  @Input() show: boolean | null = false;

  @ViewChild('dynamic', { static: true, read: ViewContainerRef })
  viewContainerRef: ViewContainerRef;

  component: ComponentRef<any>;

  protected constructor(public mandantConfigService: MandantConfigService) {}

  ngOnInit() {
    this.component = this.getComponent();
    this.component.instance.show = this.show;
  }

  ngOnChanges(changes: SimpleChanges) {
    const change = changes['show'];
    if (this.component?.instance) {
      this.component.instance.show = change?.currentValue;
    }
  }

  protected abstract getComponent();
}
